// src/constants/colors.js
const PALETTE = {
    // Paleta Sênior Shopping (baseada no index.html):
    //primary: "#163C53", // Azul Institucional (azul-inst)
    primary: "#163C53",
    secondary: "#82A097", // Verde Saúde (verde-saude)
    accent: "#CBA34B", // Dourado (dourado)

    // Cores adicionais do tema
    bege: "#F1E9D4", // Bege Fundo
    azulClaro: "#4A6FAF", // Azul Claro

    neutrals: {
        background: "#F1E9D4", // Bege (Para o fundo da página)
        surface: "#FFFFFF", // Branco (Para o fundo de cards)
        text: "#163C53", // Texto Azul Institucional
        muted: "#6b7280", // Texto Secundário
    },

    states: {
        success: "#10b981",
        warning: "#facc15",
        error: "#ef4444",
        info: "#3b82f6",
    },

    // Cores específicas do Sênior Shopping (para uso direto)
    seniorShopping: {
        azulInst: "#163C53",
        dourado: "#CBA34B",
        begeFundo: "#F1E9D4",
        verdeSaude: "#82A097",
        azulClaro: "#4A6FAF",
        branco: "#FFFFFF",
    },
};

module.exports = { PALETTE };